<template>
  <div>
    <router-link :to="back" :class="TEXT_BUTTON">← {{ backLabel }}</router-link>
    <div class="mt-2 flex items-start gap-4">
      <div class="min-w-0">
        <div class="flex items-center gap-3">
          <h2 class="text-[18px] font-semibold text-gray-900 truncate">{{ title }}</h2>
          <slot name="badges" />
        </div>
        <div v-if="meta || $slots.meta" class="mt-1 text-gray-500">
          <slot name="meta">{{ meta }}</slot>
        </div>
      </div>
      <div v-if="$slots.actions" class="ml-auto flex shrink-0 items-center gap-3">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
import { TEXT_BUTTON } from './hermes';

export default {
  name: 'HermesRecordHeader',
  props: {
    back: { type: Object, required: true },
    backLabel: { type: String, required: true },
    title: { type: String, required: true },
    meta: { type: String, default: '' },
  },
  data() {
    return { TEXT_BUTTON };
  },
};
</script>
